<div class="contenedor my-2">
    <div (mouseleave)="hover = 0" >
        <button class="btn-star" (mouseover)="hover = idx + 1" mat-icon-button [color]="color" *ngFor="let ratingId of ratingArr;index as idx" [id]="'star_'+idx"
            (click)="onClick( idx + 1 )">
            <mat-icon *ngIf="!hover">
                {{rating >= idx + 1 ? 'star' : 'star_border'}}
            </mat-icon>
            <mat-icon *ngIf="hover">
                {{hover >= idx + 1 ? 'star' : 'star_border'}}
            </mat-icon>
        </button>
        <!-- <mat-error *ngIf="starCount == null || starCount == 0">
            Star count is <strong>required</strong> and cannot be zero
        </mat-error> -->
    </div>
    <p class="mb-0 texto">
       <span *ngIf="!hover">{{rating}} / {{starCount}}</span>
       <span *ngIf="hover">{{hover}} / {{starCount}}</span>
    </p>
</div>